/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Private_Models_Connection_Delete_DescriptionInputs */



/**
* | output |
* | --- |
* | "\"{name}\" and its {count} models are removed, along with every organization and team selection of them." |
*
* @param {Private_Models_Connection_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_delete_description = /** @type {((inputs: Private_Models_Connection_Delete_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_Delete_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.name}" und seine ${i?.count} Modelle werden entfernt, ebenso alle Organisations- und Team-Auswahlen davon.`)
	return /** @type {LocalizedString} */ (`"${i?.name}" and its ${i?.count} models are removed, along with every organization and team selection of them.`)
});